import React from "react";

interface ToggleInputProps {
  isToggled: boolean;
  onToggle: () => void;
  size?: "sm" | "md" | "lg"; // optional size control
}

const ToggleInput: React.FC<ToggleInputProps> = ({
  isToggled,
  onToggle,
  size = "md",
}) => {
  const sizes = {
    sm: {
      track: "w-8 h-4",
      thumb: "w-3 h-3",
      move: "translate-x-4",
    },
    md: {
      track: "w-10 h-5",
      thumb: "w-4 h-4",
      move: "translate-x-5",
    },
    lg: {
      track: "w-14 h-7",
      thumb: "w-6 h-6",
      move: "translate-x-7",
    },
  };

  const current = sizes[size];

  return (
    <label
      className={`relative inline-flex ${current.track} cursor-pointer items-center`}>
      <input
        type="checkbox"
        className="sr-only"
        checked={isToggled}
        onChange={onToggle}
      />

      {/* Track */}
      <span
        className={`absolute w-full h-full rounded-full transition duration-200
        ${isToggled ? "bg-bg-button-secondary" : "bg-bg-disabled"}`}
      />

      {/* Thumb */}
      <span
        className={`absolute left-0.5 rounded-full transition duration-200
        ${current.thumb}
        ${
          isToggled
            ? `bg-bg-button-primary ${current.move}`
            : "bg-bg-disabled translate-x-0"
        }`}
      />
    </label>
  );
};

export default ToggleInput;
